import React from 'react';
import PropTypes from 'prop-types';

import LoadingSpinner from 'components/ui/loading_spinner';
import PushContacts from './push_contacts';
import PushResults from './push_results';
import { steps } from './push_contacts_constants';
import PushStatus from './push_status';

export default class PushContactsContainer extends React.Component {
  static propTypes = {
    batch: PropTypes.object,
    editUserPath: PropTypes.string,
    email: PropTypes.string.isRequired,
    handlePushContactsPath: PropTypes.string.isRequired,
    isSameUser: PropTypes.bool,
    profileSettingsPath: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
    pushContactsPath: PropTypes.string.isRequired,
    user: PropTypes.object
  }

  state = {
    currentStep: 1,
    batch: this.props.batch
  }

  changeCurrentStep = step => this.setState({ currentStep: step });
  updateBatch = batch => this.setState({ batch });

  componentDidMount() {
    const { batch } = this.props;

    if (batch.status === 'running') {
      this.changeCurrentStep(steps.pushContacts);
    } else if (batch.status === 'completed') {
      this.changeCurrentStep(steps.pushResults);
    }
  }

  render() {
    const { profileSettingsPath, editUserPath, isSameUser } = this.props;
    const { currentStep, batch } = this.state;

    switch (currentStep) {
    case steps.selectContacts: {
      return (
        <PushContacts
          {...this.props}
          batch={batch}
          onChangeBatch={this.updateBatch}
          onChangeStep={this.changeCurrentStep}
        />
      );
    }
    case steps.pushContacts: {
      return (
        <React.Fragment>
          <LoadingSpinner />
          <PushStatus
            batch={batch}
            onChangeStep={this.changeCurrentStep}
          />
        </React.Fragment>
      );
    }
    case steps.pushResults: {
      return (
        <PushResults
          batch={batch}
          editUserPath={editUserPath}
          isSameUser={isSameUser}
          profileSettingsPath={profileSettingsPath}
          onChangeStep={this.changeCurrentStep}
        />
      );
    }
    default:
      return (
        <span>Invalid Step Defined</span>
      );
    }
  }
}
